/**
 * Represents a return to search component.
 */
export default class ReturnToSearchAnchor {
  /**
   * Creates a new instance of ReturnToSearchAnchor.
   * @constructor
   */
  constructor() {
    this.buttonId = 'returnToSearchBtn';
  }

  /**
   * Gets the anchor element by ID.
   * @returns {HTMLElement} The anchor element.
   */
  getAnchor() {
    return document.getElementById(this.buttonId);
  }

  /**
   * Gets the HTML for the return to search anchor component.
   * @returns {string} The HTML for the return to search anchor component.
   */
  getHtml() {
    return `
      <button id="${this.buttonId}" class="btn btn--white btn--48-lg" data-close> 
        Return to Search
      </button>`;
  }
}